import { Typography as MuiTypography } from '@mui/material';

import type { TypographyProps } from './types';

export function Typography(props: TypographyProps) {
  return <MuiTypography {...props} />;
}
